import React, {useState, useEffect}					from 'react';

import Checkbox										from '../Checkbox';
import Modal										from '../Modal';

import {useAppSelector}								from '../../../app/hooks';
import {FilterChecked, FilterData}					from '../Modal/interface';
import {LanguageFilters}							from '../../language/type';
import {Tags}										from '../ModalTags/interface';
import {DevicesState}								from '../../../redux/devices/interface';

import {ft_formatFirstUpperCase}					from '../../functions/format';

import LANGUAGE										from '../../language';

import './ModalFilter.css';

interface Props {
	filters: FilterChecked[],
	setFilters: (newFilters: FilterChecked[]) => void
	onClose: () => void,
	isOrder?: boolean,
	isContract?: boolean,
	isSupport?: boolean,
	isUser?: boolean,
	isMdm?: boolean,
	customFilter?: FilterData[],
	tagsList?: Tags[],
	companyIsPro?: boolean,
	devicesMdm?: DevicesState['mdm']
}

const FILTER: FilterData[] = [
	{
		name:    'deviceType',
		key:     'type',
		filters: ['computer', 'tablet', 'phone', 'other']
	},
	{
		name:    'deviceStatus',
		key:     'status',
		filters: ['active', 'stock', 'replacement']
	},
	{
		name:    'supplier',
		key:     'isValala',
		filters: ['valala', 'notValala']
	},
	{
		name:    'tags',
		key:     'tags',
		filters: []
	}
];

const FILTER_ORDER: FilterData[] = [
	{
		name:    'orderStatus',
		key:     'status',
		filters: ['underReview', 'beingValidated', 'refusedByFunder', 'needDocument', 'contractToBeSigned', 'inPreparation', 'shipped', 'delivered']
	}
];

const FILTER_CONTRACT: FilterData[] = [
	{
		name:    'supplier',
		key:     'isValala',
		filters: ['valala', 'notValala']
	},
	{
		name:    'tags',
		key:     'tags',
		filters: []
	},
	{
		name:    'contractStatus',
		key:     'status',
		filters: ['needAction', 'sign', 'locationEnd']
	}
];

const FILTER_SUPPORT: FilterData[] = [
	{
		name:    'supportStatus',
		key:     'status',
		filters: ['new', 'done', 'replacement', 'inProgress']
	}
];

const FILTER_MDM: FilterData[] = [
	{
		name:    'deviceType',
		key:     'type',
		filters: ['computer', 'tablet', 'phone']
	}
];

const FILTER_USER: FilterData[] = [{name: 'tags', key: 'tags', filters: []}];

function ModalFilter(props: Props) {
	const lang = useAppSelector(state => state.settings.lang);

	const [filterChecked, set_filterChecked] = useState<FilterChecked[]>([]);

	const TEXTE = LANGUAGE(lang);

	useEffect(() => set_filterChecked(JSON.parse(JSON.stringify(props.filters))), [props.filters]);

	function renderFilter() {
		const render: React.ReactElement[] = [];
		let useFilter = [...FILTER];

		if (props.isOrder)
			useFilter = FILTER_ORDER;
		else if (props.isContract)
			useFilter = FILTER_CONTRACT;
		else if (props.isSupport)
			useFilter = FILTER_SUPPORT;
		else if (props.customFilter)
			useFilter = props.customFilter;
		else if (props.isUser)
			useFilter = FILTER_USER;
		else if (props.isMdm)
			useFilter = FILTER_MDM;
		else if (props.companyIsPro && props.devicesMdm) {
			const mdmList = Object.entries(props.devicesMdm).filter(mdm => mdm[1].length);

			if (mdmList.length) {
				useFilter.unshift({
					name:    'deviceMdm',
					key:     'mdm',
					filters: mdmList.map(mdm => ft_formatFirstUpperCase(mdm[0]))
				});
			}
		}

		useFilter.forEach((filterGroup) => {
			if (filterGroup.key === 'tags' && !props.tagsList)
				return;

			const renderCheck: React.ReactElement[] = [];
			const groupIndex = filterChecked.findIndex(find => find.key === filterGroup.key);
			let useValues = filterGroup.filters;

			if (filterGroup.key === 'tags')
				useValues = props.tagsList ? props.tagsList.map(e => e.name) : [];

			useValues.forEach((filterValue) => {
				const onClick = () => {
					const copy = [...filterChecked];

					if (groupIndex === -1)
						copy.push({key: filterGroup.key, values: [filterValue]});
					else {
						if (filterIndex === -1)
							copy[groupIndex].values.push(filterValue);
						else
							copy[groupIndex].values.splice(filterIndex, 1);

						if (copy[groupIndex].values.length === 0)
							copy.splice(groupIndex, 1);
					}

					set_filterChecked(copy);
				};
				const filterIndex = groupIndex !== -1 ? filterChecked[groupIndex].values.findIndex(find => find === filterValue) : -1;

				if (filterValue in TEXTE.filters && typeof(filterValue) !== 'string')
					renderCheck.push(<span>{TEXTE.filters[filterValue]}</span>);

				let renderValue = filterValue;

				if (typeof filterValue === 'boolean')
					renderValue = filterValue ? TEXTE.global.yes : TEXTE.global.no;

				renderCheck.push(
					<div onClick={onClick} className={'modalFilterItem'}>
						<Checkbox active={filterIndex !== -1} />
						<span>{TEXTE.filters[filterValue as keyof LanguageFilters] || renderValue}</span>
					</div>
				);
			});

			render.push(
				<div className={'modalFilterContainer'}>
					<span>{TEXTE.filters[filterGroup.name]}</span>
					{renderCheck}
				</div>
			);
		});

		return render;
	}

	return (
		<Modal
			modalRight
			headerSeparation
			onClose={props.onClose}
			footerFlexDirection={'column'}
			header={TEXTE.users.modal.filterSearch}
			cancelButtonText={TEXTE.global.resetFilter}
			cancelButton={() => {
				props.setFilters([]);
				props.onClose();
			}}
			confirmButton={() => {
				props.setFilters(JSON.parse(JSON.stringify(filterChecked)));
				props.onClose();
			}}
		>
			{renderFilter()}
		</Modal>
	);
}

export default ModalFilter;